import { calendarDate, clockTime } from './eventContract'

export const formatExploreDate = (value, locale = 'en-US') => {
  if (!value) return ''
  const date = calendarDate(value)
  return new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' })
    .format(new Date(`${date}T12:00:00Z`))
}

export const formatExploreTime = (value, locale = 'en-US') => {
  const time = clockTime(value)
  if (!time) return ''
  const [hour, minute] = time.split(':').map(Number)
  return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' })
    .format(new Date(Date.UTC(2000, 0, 1, hour, minute)))
}

export const formatExploreSchedule = (schedule = {}, locale = 'en-US') => {
  const time = formatExploreTime(schedule.startTime, locale)
  return formatExploreDate(schedule.startDate, locale) + (time ? ` · ${time}` : '')
    + (schedule.timeZone ? ` · ${schedule.timeZone.replace(/_/g, ' ')}` : '')
}

export const formatExploreLocation = (location = {}) => {
  const distance = Number.isFinite(location?.distanceMiles)
    ? `${Number(location.distanceMiles).toFixed(1).replace(/\.0$/, '')} mi away`
    : ''
  return [location?.label, distance].filter(Boolean).join(' · ') || 'Location to be announced'
}
